let defaultLesson = {
    id: null,
    module_id: null,
    title: '',
    description: null,
    type: 'theory',
    order: null,
    is_active: true,
    is_required: false,
    content: {
        html: null
    },
    practical_task: {
        task_text: null,
        manager_comment: null
    },
    test: {
        id: null,
        lesson_id: null,
        title: '',
        description: '',
        questions_limit: null,
        order_mode: 'ordered',
        questions: []
    },
    created_at: null,
    updated_at: null
};

export default defaultLesson;
